import React, { useCallback, useMemo, useState } from 'react';
import { createFormView } from '../../../services/form-view';
import { Form } from '../../../ui/form/components/form/form';
import styles from './events-repeater.module.scss';
import { useForm } from '../../../contexts/form-context';
import { useFieldValidation } from '../../../contexts/field-validation-context';
import { useFormFields } from '../../../ui/form/contexts/form-fields-context';
import { useFieldActions } from '../../../contexts/field-actions-context';
const NO_ERRORS = [];
export const EventsRepeaterBase = _ref => {
  let {
    label,
    fields,
    layout,
    id,
    value,
    onChange,
    validation,
    errors = NO_ERRORS,
    FieldLayout,
    LabelComponent,
    GuestInputComponent
  } = _ref;
  const [repeatCount, setRepeatCount] = useState((value == null ? void 0 : value.length) || 0);
  const currentValue = useMemo(() => value ?? [], [value]);
  const formSchema = useForm();
  const formFields = useFormFields();
  const fieldActions = useFieldActions();
  const {
    validateFields
  } = useFieldValidation();
  const guestLimit = validation.predefined.objectArrayOptions.maxItems;
  const formView = createFormView({
    form: {
      fields,
      steps: [{
        layout
      }]
    },
    parentId: id,
    recursive: false
  });
  const errorsByIndex = errors.reduce((acc, error) => {
    const [indexStr, errorPath] = error.errorPath.split('/');
    const index = parseInt(indexStr, 10);
    if (!acc[index]) {
      acc[index] = [];
    }
    acc[index].push({
      ...error,
      errorPath
    });
    return acc;
  }, []);
  const handleFieldChange = useCallback(index => (fieldTarget, fieldValue) => {
    const newValues = Array.from({
      length: repeatCount
    }, (_, i) => currentValue[i] ?? {});
    newValues[index] = {
      ...newValues[index],
      [fieldTarget]: fieldValue
    };
    onChange == null || onChange(newValues);
  }, [onChange, currentValue, repeatCount]);
  const handleValueChange = useCallback(newValue => {
    setRepeatCount(newValue);
    onChange == null || onChange(Array.from({
      length: newValue
    }, (_, i) => currentValue[i] ?? {}));
  }, [onChange, currentValue, setRepeatCount]);
  const handleNumberInputChange = useCallback(stringValue => {
    const newValue = parseInt(stringValue, 10);
    if (newValue > guestLimit) {
      handleValueChange(guestLimit);
    } else if (newValue < 0 || isNaN(newValue)) {
      handleValueChange(0);
    } else {
      handleValueChange(newValue);
    }
  }, [guestLimit, handleValueChange]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => guestLimit > 1 && /*#__PURE__*/React.createElement(LabelComponent, {
      label: label,
      required: false,
      hideLabel: false
    }),
    renderInput: () => /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement(GuestInputComponent, {
      label: label,
      guestLimit: guestLimit,
      repeatCount: repeatCount,
      onCheckboxChange: checked => handleValueChange(checked ? 1 : 0),
      onNumberInputChange: handleNumberInputChange
    }), Array.from({
      length: repeatCount
    }, (_, index) => /*#__PURE__*/React.createElement(Form, {
      key: index,
      form: formView,
      formSchema: formSchema,
      values: currentValue[index] ?? {},
      errors: errorsByIndex[index] ?? [],
      validateFields: validateFields,
      onFieldChange: handleFieldChange(index),
      fields: formFields,
      fieldActions: fieldActions
    }))),
    renderDescription: () => null
  });
};
//# sourceMappingURL=events-repeater-base.js.map